import { useCallback } from 'react';

import { useArtistSubscriptionsContext } from './ArtistSubscriptionsContext';

export interface UseArtistSubscriptionResult {
  follow: () => Promise<void>;
  unfollow: () => Promise<void>;
  isPending: boolean;
  isSubscribed: boolean;
}

/**
 * Per-row view over the artist subscription group keyed by `artistId`. Follow
 * and unfollow act on the whole group, the artist sub plus the product/release
 * subs that resolve to it, via the shared context. Member state is centralised
 * there because collab subs are referenced by more than one row.
 */
export const useArtistSubscription = (
  artistId: string,
): UseArtistSubscriptionResult => {
  const { followGroup, isFollowed, isPending, unfollowGroup } =
    useArtistSubscriptionsContext();

  return {
    follow: useCallback(() => followGroup(artistId), [followGroup, artistId]),
    unfollow: useCallback(
      () => unfollowGroup(artistId),
      [unfollowGroup, artistId],
    ),
    isPending: isPending(artistId),
    isSubscribed: isFollowed(artistId),
  };
};
